import { FC, PropsWithChildren, createContext, useMemo, useState } from "react";
import { GRID_IDENTIFIERS } from "../../../contexts/types";
import { useLocalStorage } from "../../../Hooks/useLocalStorage";
import store from "../../../store";

interface GenericProGridContextProps {
    gridIdentifier: `${GRID_IDENTIFIERS}`;
}

export const GenericProGridContext = createContext<any>({
    identifier: undefined,
    activeGridConfig: undefined,
    activeGridState: null,
    incomingGridState: null,
    defaultGridState: null,
    resetIncomingState: () => {
        // This is intentional
    },
    setIncomingGridState: () => {
        // This is intentional
    },
    setActiveGridState: () => {
        // This is intentional
    },
    setDefaultGridState: () => {
        // This is intentional
    },
    setActiveGridConfigMetadata: () => {
        // This is intentional
    },
});

const GenericProGridProvider: FC<PropsWithChildren<GenericProGridContextProps>> = ({ children, gridIdentifier }) => {
    const [incomingGridState, setIncomingGridState] = useState<any>(null);
    const [activeGridState, setActiveGridState] = useState<any>(null);
    const [defaultGridState, setDefaultGridState] = useState<any>(null);

    const { value: activeGridConfigMetadata, setStorageValue: setStorageActiveGridConfigMetadata } = useLocalStorage<{ id: number; name: string } | null>(
        `active-grid-config.${gridIdentifier}.${store.getState().userReducer.tenant.organization.id}.${store.getState().userReducer.user.personId}`,
        null,
    );

    const value = useMemo(
        () => ({
            activeGridState,
            setActiveGridState,
            incomingGridState,
            setIncomingGridState,
            defaultGridState,
            setDefaultGridState,
            resetIncomingState: () => setIncomingGridState(null),
            identifier: gridIdentifier,
            activeGridConfigMetadata,
            setActiveGridConfigMetadata: (item: { id: number; name: string; isGlobal: boolean } | null) => setStorageActiveGridConfigMetadata(item),
        }),
        [activeGridState, incomingGridState, defaultGridState, gridIdentifier, activeGridConfigMetadata, setStorageActiveGridConfigMetadata],
    );

    return <GenericProGridContext.Provider value={value}>{children}</GenericProGridContext.Provider>;
};

export default GenericProGridProvider;
